import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Badge, Box, Button, Drawer, IconButton, Tooltip, Typography, TextField, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useStyles } from "./styles";
import { icons } from "../../../../../../../../utils/icons";
import { UploadEvidence } from "../../../../../../../../components/uploadEvidence";
import { Evidence, EvidenceTypeData, EVIDENCE_TYPES } from "./types";
import { reportFolioServices } from "../../../../../../../../utils/constants/callService";
import { useGetData } from "../../hooks/useGetData";
import { ConfirmModal } from "../historial/Components";
import { SnackSimple } from "../../../../../../../../components";
import { Types } from "../../../../../../../../utils/enums/types";
import { VIEW_TYPES } from './../../types/ViewTypes';
import { RatingModal } from "../historial/Components";
import { EvidenceState } from "../../../FormPreventive/Interfaces";
import { EvidencesFormat } from "../../../FormCorrective/Interfaces";
import { EvidencesTypeValueEnum } from "../../../../../../../../utils/enums/evidences";

export const ApproveRejectSolutionForm = ({ onAttend, type, list }) => {

  const styles = useStyles();
  const { t } = useTranslation();
  const { id } = useParams();
  const { data } = useGetData({ id });
  const { historial, left, right } = data;
  const [alertModals, setAlertModals] = useState(false);
  const [messageAlertModals, setMessageAlertModals] = useState("");
  const [openUploadEvidence, setOpenUploadEvidence] = useState(false);
  const [evidencesRequiredAreLoad, setEvidencesRequiredAreLoad] = useState({});
  const [commentUpload, setCommentUpload] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [evidencesDrawer, setEvidencesDrawer] = useState<EvidencesFormat>({
    open: false,
    type: {
      equivalence: [],
      accept: '',
    },
  })
  const [ratingModalOpen, setRatingModalOpen] = useState(false);
  const [rating, setRating] = useState<number | null>(null);
  const [ratingComment, setRatingComment] = useState('');
  const [modalOpen, setModalOpen] = useState(false);
  let idQuote: number;
  if (historial) {
    idQuote = historial.items[0].idQuote;
  }
  const countFolio = left?.folio
  const idFolio = left?.id
  const isApprove = type === 'approve'

  const handleRatingConfirm = async (rating: number, comment?: string) => {
    const body = {
      rating,
      ...(comment && { ratingComment: comment })
    };

    try {
      const response = await reportFolioServices.ratingReportFolio({
        id: Number(idFolio),
        body
      });
      return response;
    } catch (error) {
      console.error('Error al enviar la calificación:', error);
      throw error;
    }
  };

  const handleRatingSubmit = async (ratingValue: number | null, comment?: string) => {
    if (ratingValue !== null) {
      try {
        await handleRatingConfirm(ratingValue, comment);
        setRating(ratingValue);
        setRatingComment(comment || '');
        setRatingModalOpen(false);
        onAttend(VIEW_TYPES.TAB_SWITCHER);
        window.onbeforeunload = null;
        window.location.reload()
        /* setModalOpen(true); */ // Open the confirmation modal after successful rating
      } catch (error) {
        // Handle error case
        setMessageAlertModals(t("reportFolio.detail.general.ratingError"));
        setAlertModals(true);
      }
    } else {
      setRatingModalOpen(false);
      onAttend(VIEW_TYPES.TAB_SWITCHER);
      window.onbeforeunload = null;
      window.location.reload()
      /* setModalOpen(true); */
    }
  };


  useEffect(() => {
    if (!left) {
      setIsLoading(true);
      return;
    }

    const evidenceConfig: any = {};
    const evidences = isApprove ? left?.approverEvidence : left?.rejectEvidence;

    if (evidences && evidences.length > 0) {
      evidences.forEach(evidenceType => {
        evidenceConfig[evidenceType.evidence] = {
          expanded: false,
          seeFiles: true,
          required: evidenceType.isRequired,
          maxCount: evidenceType.amount,
          customeTitle: getEvidenceTitle(evidenceType.evidence),
          minAmount: evidenceType.isRequired ? (evidenceType?.min || 1) : 0,
          size: 255,
          value: {},
          accept: evidenceType?.type
            ? evidenceType?.type.map((t: string) => `.${t}`).join(',')
            : '',
        };
      });
    }

    setEvidencesDrawer(prev => ({
      ...prev,
      value: evidenceConfig,
      open: prev.open,
    }));

    setTimeout(() => setIsLoading(false), 1000);
  }, [left, isApprove]);

  const getEvidenceTitle = (evidenceTypeId: number) => {
    const matchedType = Object.values(EVIDENCE_TYPES).find(type => type.id === evidenceTypeId);
    return matchedType?.description /* ? matchedType.descripcion : "Evidencia" */;
  };

  const hasRequiredEvidences = () => {
    if (!evidencesDrawer.value) return false;

    return Object.entries(evidencesDrawer.value).every(([_, type]) => {
      const typeData = type as EvidenceTypeData;
      if (typeData.required) {
        const filesCount = Object.keys(typeData.value || {}).length;
        return filesCount >= typeData.minAmount;
      }
      return true;
    });
  };


  const handleOpenUpload = () => {
    setOpenUploadEvidence(true);
    setEvidencesDrawer((prev) => ({
      ...prev,
      open: true,
    }));
  };

  const handleCloseUpload = () => {
    setOpenUploadEvidence(false);
    setEvidencesDrawer((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleSentData = async () => {
    if (!hasRequiredEvidences()) {
      setMessageAlertModals(t("reportFolio.detail.general.requiredEvidencesMessage"));
      setAlertModals(true);
      return;
    }

    const evidences: Evidence[] = [];
    const comments: string[] = [];
    const evidenceTypeId = isApprove
      ? right?.descriptionApprove?.evidenceTypeId
      : right?.descriptionReject?.evidenceTypeId;

    if (evidencesDrawer.value) {
      Object.entries(evidencesDrawer.value).forEach(([typeId, typeData]) => {
        if (typeData.value) {
          Object.values(typeData.value).forEach(file => {
            if (file.url && Number(typeId) !== EvidencesTypeValueEnum.COMMENT && Number(typeId) !== EvidencesTypeValueEnum.OBSERVATION_COMMENT) {
              evidences.push({
                url: String(file.url),
                originalname: file.name,
                evidenceTypeId: Number(typeId),
              });
            }
            if ((Number(typeId) === EvidencesTypeValueEnum.OBSERVATION_COMMENT || Number(typeId) === EvidencesTypeValueEnum.COMMENT) && file.url) {
              comments.push(String(file.url));
            }
          });
        }
      });
    }

    let response;
    if (isApprove) {
      response = await reportFolioServices.approveReportFolio({
        id: idFolio ?? 0,
        body: {
          evidences,
          comments,
          reasonOfApproval: commentUpload
        }
      });
    } else {
      response = await reportFolioServices.rejectReportFolio({
        id: idFolio ?? 0,
        body: {
          evidences,
          comments,
          reasonOfRejection: commentUpload,

        }
      });
    }

    if (response.code === "00" || response.id) {
      setMessageAlertModals(
        isApprove
          ? t("reportFolio.detail.general.confirmSolutionTitleSuccessApprove")
          : t("reportFolio.detail.general.confirmSolutionTitleSuccessReject")
      );
      setAlertModals(true);
      setModalOpen(false);

      if (isApprove && left?.rating?.showRating) {
        setRatingModalOpen(true);
      } else {
        onAttend(VIEW_TYPES.TAB_SWITCHER);
      }

    } else {
      setMessageAlertModals(
        isApprove
          ? t("reportFolio.detail.general.confirmSolutionTitleErrorApprove")
          : t("reportFolio.detail.general.confirmQuotationTitleErrorReject")
      );
      setAlertModals(true);
      setModalOpen(false);
    }
  };



  const handleCloseAlertsModal = () => {
    setAlertModals(false);
  };

  const handleApproveButtonClick = () => {
    setModalOpen(true);
  };

  if (isLoading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "50vh" }}>
        <CircularProgress />
      </Box>
    );
  }


  return (
    <Box>
      <Box sx={styles.container}>
        <Box sx={styles.centerContainer}>
          {list ?
            <Typography fontWeight="bold">
              {isApprove ? t("reportFolio.detail.general.sendSolutionApproveList") : t("reportFolio.detail.general.sendSolutionRejectList")}
            </Typography>
            :
            <Typography fontWeight="bold">
              {isApprove ? t("reportFolio.detail.general.sendSolutionApprove") : t("reportFolio.detail.general.sendSolutionReject")}
            </Typography>
          }

          <Typography>
            {isApprove ? t("reportFolio.detail.general.sendSolutionApproveDescription") : t("reportFolio.detail.general.sendSolutionRejectDescription")}
          </Typography>



        </Box>
      </Box>

      <Box sx={styles.commentContainer}>

        <Box sx={styles.commentStyles}>
          <TextField
            fullWidth
            multiline
            rows={4}
            value={commentUpload}
            onChange={(e) => {
              const value = e.target.value;
              if (value.length <= 255) {
                setCommentUpload(value);
              }
            }}
            label={t("general.comment")}
            margin="normal"
            error={commentUpload.length > 255}
            inputProps={{ maxLength: 255 }}
          />
        </Box>
      </Box>

      <Box sx={styles.buttonsContainer}>
        <Button onClick={onAttend}>{t("general.cancel")}</Button>

        <Box sx={styles.lastButtons}>
          {evidencesDrawer.value && Object.keys(evidencesDrawer.value).length > 0 && (
            <>
              {!hasRequiredEvidences() && (
                <Badge
                  sx={styles.badge}
                  badgeContent={
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {icons("priorityHigh")}
                    </Box>
                  }
                >
                  <Tooltip title={t("ToolTips.seeEvidences")}>
                    <IconButton
                      onClick={handleOpenUpload}
                      sx={styles.clip}
                      color="error"
                    >
                      {icons("clip")}
                    </IconButton>
                  </Tooltip>
                </Badge>
              )}

              {hasRequiredEvidences() && (
                <Tooltip title={t("ToolTips.seeEvidences")}>
                  <IconButton
                    onClick={handleOpenUpload}
                    sx={styles.clip}
                    color="default"
                  >
                    {icons("clip")}
                  </IconButton>
                </Tooltip>
              )}
            </>
          )}

          <Button
            variant="contained"
            onClick={handleApproveButtonClick}
            disabled={
              !commentUpload.trim() ||
              commentUpload.length > 255 ||
              !hasRequiredEvidences()
            }
          >
            {isApprove ? t("reportFolio.detail.general.approve") : t("reportFolio.detail.general.reject")}
          </Button>
        </Box>

      </Box>

      <Drawer
        anchor="right"
        open={evidencesDrawer.open}
        onClose={handleCloseUpload}
        PaperProps={{
          sx: {
            width: "30%",
          },
        }}
      >
        <Box p={2} sx={{ width: "100%", display: "flex", flexDirection: "column" }}>
          <Typography variant="h6" gutterBottom>
            {t("reportFolio.detail.general.evidencesDetail")}
          </Typography>

          {openUploadEvidence && (
            <UploadEvidence
              uploadName={`folios/${countFolio}/${isApprove ? 'approve' : 'reject'}`}
              evidencesDrawer={evidencesDrawer as EvidenceState}
              evidencesRequiredAreLoad={evidencesRequiredAreLoad}
              showRequireds={false}
              //@ts-ignore
              setEvidencesDrawer={setEvidencesDrawer}
              setEvidencesRequiredAreLoad={setEvidencesRequiredAreLoad}
              close={handleCloseUpload}
            /* evidenceTypeId={isApprove
              ? right?.descriptionApprove?.evidenceTypeId
              : right?.descriptionReject?.evidenceTypeId} */
            />
          )}
        </Box>
      </Drawer>

      <RatingModal
        open={ratingModalOpen}
        onClose={() => {
          setRatingModalOpen(false);
          onAttend(VIEW_TYPES.TAB_SWITCHER);
          window.onbeforeunload = null;
          window.location.reload();
        }}
        onConfirm={handleRatingSubmit}
        isOptional={!left?.rating?.required}
        text={left?.rating?.ratingQuestion ?? ""}
      />

      <ConfirmModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleSentData}
        simpleText
        reload={isApprove ? !left?.rating?.showRating ? undefined : () => { } : undefined}
        title={isApprove ? t("reportFolio.detail.general.confirmTitle") : t("reportFolio.detail.general.confirmTitle")}
        description={
          list ?
            isApprove ? t("reportFolio.detail.general.confirmSolutionDescriptionList") : t("reportFolio.detail.general.rejectSolutionDescriptionList")
            :
            isApprove ? t("reportFolio.detail.general.confirmSolutionDescription") : t("reportFolio.detail.general.rejectSolutionDescription")
        }
      />
      <SnackSimple
        open={alertModals}
        close={handleCloseAlertsModal}
        message={messageAlertModals}
        type={Types.SUCCESS}
      />
    </Box>
  );
};